import differenceInDays from "date-fns/differenceInDays";

export default d => (d ? differenceInDays(new Date(), d) : "N/A");
